var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/personalcard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "personalcard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.1667 38.5H12.8334C5.50008 38.5 3.66675 36.6667 3.66675 29.3333V14.6667C3.66675 7.33333 5.50008 5.5 12.8334 5.5H31.1667C38.5001 5.5 40.3334 7.33333 40.3334 14.6667V29.3333C40.3334 36.6667 38.5001 38.5 31.1667 38.5Z",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.6667 14.6665H34.8334",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.5 22H34.8333",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.1667 29.3335H34.8334",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.5832 20.6982C17.4159 20.6982 18.9016 19.2125 18.9016 17.3799C18.9016 15.5472 17.4159 14.0615 15.5832 14.0615C13.7506 14.0615 12.2649 15.5472 12.2649 17.3799C12.2649 19.2125 13.7506 20.6982 15.5832 20.6982Z",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.0001 29.9382C21.7434 27.2799 19.6351 25.1899 16.9767 24.9516C16.0601 24.8599 15.1251 24.8599 14.1901 24.9516C11.5317 25.2082 9.42341 27.2799 9.16675 29.9382",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalcard);
export default __webpack_public_path__ + "static/media/personalcard.dfe25482d7466ba00a9946f698b6f14b.svg";
export { ForwardRef as ReactComponent };